package com.appsyde.shared.modules.ai.data.dto

import kotlinx.serialization.Serializable

@Serializable
data class AiErrorResponse(
    val error: String,
    val message: String,
    val details: String? = null,
    val upstreamStatus: String? = null,
    val upstreamBody: String? = null
)
